import { defineMessages } from 'react-intl';

export default defineMessages({
  1: {
    id: 'global_venta_select',
    defaultMessage: 'Property for sale',
    description: 'homes',
  },
  2: {
    id: 'global_alquiler_select',
    defaultMessage: 'Property for rent',
    description: 'homes',
  },
  5: {
    id: 'global_compartir_piso_select',
    defaultMessage: 'Flatshare',
    description: 'homes',
  },
  6: {
    id: 'global_alquiler_parking_select',
    defaultMessage: 'Parking spaces for rent',
    description: 'homes',
  },
  7: {
    id: 'global_venta_parking_select',
    defaultMessage: 'Parking spaces for sale',
    description: 'homes',
  },
  8: {
    id: 'global_alquiler_oficinas_select',
    defaultMessage: 'Office space for rent',
    description: 'homes',
  },
  9: {
    id: 'global_oficinas_select',
    defaultMessage: 'Office space for rent',
    description: 'homes',
  },
  10: {
    id: 'global_terrenos_select',
    defaultMessage: 'Land for sale',
    description: 'homes',
  },
  11: {
    id: 'global_traspaso_locales_select',
    defaultMessage: 'Commercial foreclosures',
    description: 'homes',
  },
  12: {
    id: 'global_alquiler_locales_select',
    defaultMessage: 'Commercial for rent',
    description: 'homes',
  },
  13: {
    id: 'global_venta_locales_select',
    defaultMessage: 'Commercial for sale',
    description: 'homes',
  },
  14: {
    id: 'global_alquiler_naves_select',
    defaultMessage: 'Industrial for rent',
    description: 'homes',
  },
  15: {
    id: 'global_naves_select',
    defaultMessage: 'Industrial for sale',
    description: 'homes',
  },
  16: {
    id: 'global_overseas_select',
    defaultMessage: 'Overseas property',
    description: 'homes',
  },
  17: {
    id: 'global_alquiler_temporario_select',
    defaultMessage: 'Temporary rent',
    description: 'homes',
  },
  18: {
    id: 'global_unlisted_foreclosure_select',
    defaultMessage: 'Foreclosures',
    description: 'homes',
  },
});



// WEBPACK FOOTER //
// ./app/common/forms/messages.homes.js